<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    @md-opened="openDialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
    class="md-medium-size-100 md-xsmall-size-100 md-size-100"
  >
    <md-dialog-title>Conflicted Users</md-dialog-title>
    <md-dialog-content class="user-agent">
      <h4 class="text-error">Error while changing Case Sensitivity!</h4>
      <span class="text-justify full-width"
        >There are <strong>{{ numberOfConflictedUsers }} users</strong> with similar usernames (while ignoring case),
        which should be removed (except one) before changing case sensitivity. Please remove extra users and try again.
        Here are the conflicted users (similar users has same background colors):
      </span>
      <md-table v-model="conflictedUsers" table-header-color="purple" md-card md-fixed-header>
        <md-table-row slot="md-table-row" slot-scope="{ item }" :md-disabled="item.disabled">
          <md-table-cell md-label="Username" :style="computedBackgroundColorStyle(item.lower)" class="username-col">{{
            item.application_username
          }}</md-table-cell>
          <md-table-cell :style="computedBackgroundColorStyle(item.lower)" class="table-action-buttons">
            <md-button class="md-icon-button md-dense" @click="deleteUser(item.id)" :disabled="item.disabled">
              <md-tooltip md-direction="top">Delete This User</md-tooltip>
              <md-icon>delete</md-icon>
            </md-button>
            <md-button class="md-icon-button md-dense" @click="launchUserDetailsInNewTab(item.id)">
              <md-tooltip md-direction="top">Launch User Details</md-tooltip>
              <md-icon>launch</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <div class="md-layout-item md-size-100 text-right">
        <md-button @click="closeDialog">Close</md-button>
        <md-button class="md-primary" @click="emitRefresh">Recheck</md-button>
      </div>
    </md-dialog-content>

    <delete-user
      @deleted="userDeleted"
      @close="showDeleteUser = false"
      @failed="userDeleteFailed"
      :application_user_pk="deleteUserPk"
      :show="showDeleteUser"
    ></delete-user>
  </md-dialog>
</template>

<script>
import DeleteUser from "@/components/DeleteUser";
import { ref } from "@vue/composition-api";
import NotificationStore from "@/components/NotificationPlugin/NotificationStore";

export default {
  name: "ConflictedUsersDialog",
  props: ["show", "conflictedUsers", "numberOfConflictedUsers"],
  components: { DeleteUser },
  setup: function (props, { root, emit }) {
    const openDialog = () => {
      showDeleteUser.value = false;
    };
    const closeDialog = () => {
      emit("close");
    };
    const emitRefresh = () => {
      emit("refresh");
    };

    const launchUserDetailsInNewTab = (userId) => {
      const routeData = root.$router.resolve({ name: "User Details", query: { user_pk: userId } });
      window.open(routeData.href, "_blank");
    };

    // noinspection SpellCheckingInspection
    const backgroundColors = ["F3E5F5", "E1BEE7"];
    let lastItem = undefined;
    let lastUsedIndex = -1;
    const computedBackgroundColorStyle = (lowerUsername) => {
      if (lastItem !== lowerUsername) {
        lastItem = lowerUsername;
        lastUsedIndex = (lastUsedIndex + 1) % backgroundColors.length;
      }
      return `background: #${backgroundColors[lastUsedIndex]} !important`; // important is used for disabling hover
    };

    const showDeleteUser = ref(false);
    const deleteUserPk = ref(-1);
    const deleteUser = (Pk) => {
      deleteUserPk.value = Pk;
      showDeleteUser.value = true;
    };
    const userDeleted = (message) => {
      showDeleteUser.value = false;

      for (const conflictedUser of props.conflictedUsers) {
        if (conflictedUser.id === deleteUserPk.value) {
          conflictedUser.disabled = true;
          conflictedUser.application_username = conflictedUser.application_username + " [DELETED]";
          break;
        }
      }
    };
    const userDeleteFailed = (message) => {
      NotificationStore.notify({
        message: "Server encountered error while deleting this user!",
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
      });
    };

    return {
      openDialog,
      closeDialog,
      emitRefresh,

      launchUserDetailsInNewTab,

      computedBackgroundColorStyle,

      showDeleteUser,
      deleteUserPk,
      deleteUser,
      userDeleted,
      userDeleteFailed,
    };
  },
};
</script>

<style lang="scss" scoped>
.full-width {
  max-width: 100%;
  width: 100%;
}

.username-col {
  min-width: 25vw;
}

.table-action-buttons {
  width: 100%;

  .md-table-cell-container .md-icon-button:nth-child(1) {
    margin: 0 0 0 auto;
  }
}
</style>
